module.exports = __webpack_public_path__ + "static/media/na.8114f3f9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/na.svg
// module id = 205
// module chunks = 0